'use client';

import { type LayoutNode, type LayoutNodeStyleMap } from 'shop-ui/types';
import { ELEMENT_TYPE, FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { getElementUlId } from 'app/shop-ui/tools/getElementUlId';
import { combineComponent } from 'shop-ui/tools/combineComponent';
import { GRID_LAYOUT_TYPE } from 'shop-ui/section/Grid/rules';
import i18n from '@shared/i18n';

export const componentName = 'Breadcrumb';

export enum OFFICIAL_BREADCRUMB_KEY {
    BREADCRUMB = 'official-breadcrumb',
}

// 官方 preset 的設定
export const showCutList = [
    {
        key: OFFICIAL_BREADCRUMB_KEY.BREADCRUMB,
        type: ELEMENT_TYPE.BREADCRUMB,
        content: i18n.gettext('Breadcrumb'),
        version: 2,
    },
];

const config: LayoutNode = {
    id: '',
    type: ELEMENT_TYPE.BREADCRUMB,
    name: componentName,
    enable: true, // 通常要開啟
    next: null,
    deletable: true, // 通常要開啟
};

export const features = [
    FEATURE_FLAG_KEYS.RESIZE_HANDLE,
    FEATURE_FLAG_KEYS.FONT_FAMILY,
    FEATURE_FLAG_KEYS.FONT_WEIGHT,
    FEATURE_FLAG_KEYS.FONT_SIZE_CUSTOM,
    FEATURE_FLAG_KEYS.FONT_COLOR,
];

const defaultStyle = {
    [FEATURE_FLAG_KEYS.FONT_FAMILY]: 'Inter',
    [FEATURE_FLAG_KEYS.FONT_WEIGHT]: '400',
    [FEATURE_FLAG_KEYS.FONT_SIZE]: 'custom',
    [FEATURE_FLAG_KEYS.FONT_SIZE_CUSTOM]: '12',
    [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(81, 81, 86, 1)',
    [FEATURE_FLAG_KEYS.PADDING_TOP]: '12px',
    [FEATURE_FLAG_KEYS.PADDING_BOTTOM]: '12px',
    [FEATURE_FLAG_KEYS.PADDING_LEFT]: '27px',
    [FEATURE_FLAG_KEYS.PADDING_RIGHT]: '27px',
} as const;

export function createBreadcrumb(presetStyle?: LayoutNodeStyleMap[string]) {
    const id = getElementUlId();

    const layout = {
        ...config,
        id,
    };

    return {
        id,
        layout,
        style: {
            ...defaultStyle,
            ...presetStyle,
        },
    };
}

export function generate(sectionName: string = i18n.gettext('區塊')) {
    const breadcrumb = createBreadcrumb();

    return combineComponent(sectionName, [breadcrumb], {
        primaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL, // 依照需求調整 grid type
        secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL, // 依照需求調整 grid type
        shouldWrap: true,
    });
}
